import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppConfig } from '../../app/app.config';
import { ConnectionService } from '../../services/connection-service';
import { ComparisonSliderComponent } from '../../app/compare-progress/comparison-slider/comparison-slider.component';
import { Broadcaster } from '../broadcaster';

@Component({
    selector: 'image-comparison-popup', templateUrl: './image-comparison-popup.html',
    standalone: false
})
export class ImageComparisonPopup {
  @ViewChild('slider') slider: ComparisonSliderComponent;
  imageConfig: any;

  constructor(public dialogRef: MatDialogRef<ImageComparisonPopup>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appConfig: AppConfig,
    private conn: ConnectionService,
    private broadcast: Broadcaster) {
  }

  onImagePositionChange(config: any): void {
    this.imageConfig = config;
  }

  changePhoto(instantCheckup: any): void {
    this.data.params.id2 = instantCheckup.objectId;
  }

  async hideModal(): Promise<any> {
    this.dialogRef.close();
  }

  updateImageConfig(): void {
    // Force latest coordinates before closing
    const latest = this.slider?.calculateCoordinates?.(false) ?? this.imageConfig;
    this.dialogRef.close({ config: latest, params: this.data.params });
  }
}
